import { RouteObject } from 'react-router-dom';

export const authRoutes: RouteObject[] = [
	{
		path: 'login',
		lazy: async () => {
			const { default: Component } = await import('@/features/auth/pages/LoginPage');
			return { Component };
		},
	},
	{
		path: 'beta/:token',
		lazy: async () => {
			const { default: Component } = await import('@/features/auth/pages/LoginBetaPage');
			return { Component };
		},
	},
	{
		path: 'orain/:token',
		lazy: async () => {
			const { default: Component } = await import('@/features/auth/pages/LoginBetaPage');
			return { Component };
		},
	},
	{
		path: 'forgot-password',
		lazy: async () => {
			const { default: Component } = await import('@/features/auth/pages/ResetPasswordPage');
			return { Component };
		},
		children: [
			{
				index: true,
				lazy: async () => {
					const { default: Component } = await import('@/features/auth/components/ForgotPassword');
					return { Component };
				},
			},
			{
				path: 'check-email',
				lazy: async () => {
					const { default: Component } = await import(
						'@/features/auth/components/PasswordResetCheckEmail'
					);
					return { Component };
				},
			},
			{
				path: 'reset',
				lazy: async () => {
					const { default: Component } = await import('@/features/auth/components/NewPasswordForm');
					return { Component };
				},
			},
			{
				path: 'status',
				lazy: async () => {
					const { default: Component } = await import(
						'@/features/auth/components/PasswordResetStatus'
					);
					return { Component };
				},
			},
		],
	},
	{
		path: 'sign-up',
		lazy: async () => {
			const { default: Component } = await import('@/features/auth/pages/RegisterPage');
			return { Component };
		},
		children: [
			{
				index: true,
				lazy: async () => {
					const { default: Component } = await import('@/features/auth/components/RegisterForm');
					return { Component };
				},
			},
			{
				path: 'status',
				lazy: async () => {
					const { default: Component } = await import('@/features/auth/components/RegisterStatus');
					return { Component };
				},
			},
		],
	},
];
